import React, {useEffect, useState} from 'react';
import ProcessItem from './process-item';
import ProcessModel from '../models/process';
import './scss/process-item.scss';
import Layout from './layout';
import FullScreenLoader from './full-screen';
import EmptyView from './empty-view';
import SelectBlockchain from "./select-blockchains";
import PasswordDialog from "./password-dialog";
import StatusView from "./status-view";
import SandraJsAPI from "../services/sandraJsAPI";
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";

function ProcessList(): React.ReactElement {
    const processArray: ProcessModel[] = [];
    const [processes, setProcesses] = useState(processArray);
    const [isProcessLoading, setIsProcessLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [blockchain, setBlockchain] = useState('');
    const [jetskiAction, setJetskiAction] = React.useState('');
    const [passModalShow, setPassModalShow] = React.useState(false);
    const [statusMessage, setStatusMessage] = useState({message: '', type: StatusMessageTypeEnum.none});
    const [processList, setProcessList] = useState(processArray);

    useEffect(() => {
        if (blockchain.length == 0)
            return;
        if (processList?.length > 0) {
            setProcesses(processList.filter((item: { blockchain: string; }) => {
                return item.blockchain === blockchain;
            }));
            return;
        }
        setIsProcessLoading(true);
        SandraJsAPI.getJetskiProcesses()
            .then((result) => {
                if (result.error) {
                    setStatusMessage({message: result.error.message, type: StatusMessageTypeEnum.error});
                } else {
                    if (result.data?.length > 0)
                        setProcessList(result.data);
                }
                setIsProcessLoading(false);
            })
            .catch((reason) => {
                setStatusMessage({message: reason.message, type: StatusMessageTypeEnum.error});
                setIsProcessLoading(false);
            });
    }, [blockchain, processList]);

    const handlePasswordSubmit = (phrase: string) => {
        setPassModalShow(false);
        switch (jetskiAction) {
            case "StopAll":
                doAction(phrase, "stop");
                break;
            case "RestartAll":
                doAction(phrase, "restart");
                break;
            default:
                return;
        }
    };

    const doAction = (phrase: string, action: string) => {
        setIsLoading(true);
        let ids = processes?.map(p => {
            return p.id
        });

        SandraJsAPI.doProcessAction(ids, blockchain, phrase, action)
            .then((result) => {
                if (result.error) {
                    setStatusMessage({message: result.error.message, type: StatusMessageTypeEnum.error});
                } else {
                    setStatusMessage({
                        message: "Server returned success message, please refresh the page to update the page info",
                        type: StatusMessageTypeEnum.success
                    });
                }
                setIsLoading(false);
            })
            .catch((reason) => {
                setStatusMessage({message: reason.message, type: StatusMessageTypeEnum.error});
                setIsLoading(false);
            });
    }

    let processListView = <div/>;
    if (processes && processes.length > 0) {
        processListView = (
            <div className="list-group ">
                {processes?.map((process: any, index: number) => <ProcessItem key={index} process={process}/>)}
            </div>
        );
    } else {
        processListView = isProcessLoading ? <div/> : (
            <EmptyView title="Process not found" desc="Please add new process"/>);
    }

    return (
        <Layout className="page jetski ">
            <StatusView status={statusMessage}/>
            <div className="container-fluid text-center pt-3 loading-wrapper ">
                {isProcessLoading || isLoading
                    ? <FullScreenLoader/>
                    : ''
                }
                <div>
                    <PasswordDialog
                        action={(jetskiAction === "StopAll") ? "Stop all " + blockchain + " processes of NovaStar" : "Restart all " + blockchain + " processes of NovaStar"}
                        show={passModalShow}
                        onHide={() => {
                            setPassModalShow(false);
                        }}
                        onSubmit={handlePasswordSubmit}
                    />
                    <div className="d-block pb-4 text-start">
                        <h5 className="d-inline-block text-uppercase pt-1 ps-1 ">Jetski Process List</h5>
                        <div className="d-inline-block float-end ms-2 ">
                            <SelectBlockchain
                                balor={false}
                                onLoading={() => {
                                    setIsLoading(true);
                                }}
                                onLoaded={() => {
                                    setIsLoading(false);
                                }}
                                onChange={(data) => {
                                    setBlockchain(data);
                                }}
                                setStatusMessage={(message, type) => {
                                }}
                            />
                        </div>
                        <a
                            href="/jetski/process?action=add"
                            type="button"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Add new process"
                            style={{fontSize: "14px"}}
                            className="btn btn-light float-end d-inline-block"
                        >
                            Add New Process
                        </a>
                        <a
                            href="#"
                            type="button"
                            onClick={() => {
                                setJetskiAction("RestartAll");
                                setPassModalShow(true);
                            }}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Restart all processes, if a process is not running it will be started else restarted"
                            style={{fontSize: "14px"}}
                            className="btn btn-light float-end d-inline-block me-2"
                        >
                            Restart All
                        </a>
                        <a
                            href="#"
                            type="button"
                            onClick={() => {
                                setJetskiAction("StopAll");
                                setPassModalShow(true);
                            }}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Stop all running process"
                            style={{fontSize: "14px"}}
                            className="btn btn-light float-end d-inline-block me-2"
                        >
                            Stop All
                        </a>

                    </div>
                    <h5 className="normal-text-italic fs-6 text-start mb-3">Process on <span
                        className="text-capitalize">{blockchain}</span></h5>
                    {processListView}
                </div>
            </div>
            <div/>
        </Layout>
    );
}

export default ProcessList;
